module.exports = __webpack_public_path__ + "static/media/mhd-logo.90169309.svg";